module.exports = __webpack_public_path__ + "img/team-leo@2x.ed59fb8b.jpg";